// extracted by mini-css-extract-plugin
export default {"mainContainer":"newLoopButton_mainContainer__EEBEv","newLoopButton":"newLoopButton_newLoopButton__CkNXb"};